<template>
  <layout title="Dashboard">
      <!-- This example requires Tailwind CSS v2.0+ -->
      <transition enter-active-class="duration-300 ease-out" enter-class="opacity-0" enter-to-class="opacity-100"
        leave-active-class="duration-200 ease-in" leave-class="opacity-100" leave-to-class="opacity-0">
        <div v-show="createOrganisationModal" class="fixed inset-0 z-10 overflow-y-auto">
          <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity" aria-hidden="true">
              <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <div
              class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog" aria-modal="true" aria-labelledby="modal-headline">
              <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                  <div
                    class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                    <!-- Heroicon name: exclamation -->
                    <svg class="w-6 h-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                  <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-headline">
                      Organisatie maken
                    </h3>
                    <div class="mt-2">
                      <p class="text-sm text-gray-500">
                        Een organisatie wordt gebruikt om deelnemers en campagnes te koppelen.
                      </p>
                      <div class="mt-4">
                        <label for="name" class="block text-sm font-medium text-gray-700">Naam</label>
                        <div class="mt-1">
                          <input type="text" id="name" v-model="organisationForm.name"
                            :class="{ ' border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500': errors.name }"
                            class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm"
                            placeholder="test b.v.">
                        </div>
                        <p v-if="errors.name" class="mt-2 text-sm text-red-600" id="name-error">{{ errors.name }}</p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                <button type="button"
                  class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-lightblue-600 hover:bg-lightblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500 sm:ml-3 sm:w-auto sm:text-sm"
                  @click="createOrganisation()">
                  Organisatie maken
                </button>
                <button @click="createOrganisationModal = false" type="button"
                  class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                  Annuleren
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>



      <main class="relative z-0 flex-1 overflow-y-auto focus:outline-none" tabindex="0">
        <!-- Page title & actions -->
        <div class="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
          <div class="flex-1 min-w-0">
            <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
              Organisaties
            </h1>
          </div>
          <div class="flex mt-4 sm:mt-0 sm:ml-4">
            <span class="rounded-md shadow-sm order-0 sm:order-1 sm:ml-3">
              <button type="button" @click="createOrganisationModal = true"
                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-lightblue-600 hover:bg-lightblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500 sm:ml-3 sm:w-auto sm:text-sm">
                Organisatie maken
              </button>
            </span>
          </div>
        </div>

        <!-- Projects list (only on smallest breakpoint) -->
        <div class="sm:hidden">
          <div class="px-4 sm:px-6">
            <h2 class="text-xs font-medium tracking-wide text-gray-500 uppercase">Campagnes</h2>
          </div>
          <ul class="border-t border-gray-200 divide-y divide-gray-100">
            <li>
              <a href="#" class="flex items-center justify-between px-4 py-4 hover:bg-gray-50 sm:px-6">
                <div class="flex items-center space-x-3 truncate">
                  <div class="w-2.5 h-2.5 flex-shrink-0 rounded-full bg-pink-600"></div>
                  <p class="text-sm font-medium leading-6 truncate">GraphQL API <span
                      class="font-normal text-gray-500 truncate">in Engineering</span></p>
                </div>
                <!-- Heroicon name: chevron-right -->
                <svg
                  class="w-5 h-5 ml-4 text-gray-400 transition duration-150 ease-in-out group-hover:text-gray-500 group-focus:text-gray-600"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd" />
                </svg>
              </a>
            </li>

            <!-- More project rows... -->
          </ul>
        </div>
        <!-- Projects table (small breakpoint and up) -->
        <div class="hidden mt-8 sm:block">
          <div class="inline-block min-w-full align-middle border-b border-gray-200">
            <table class="min-w-full">
              <thead>
                <tr class="border-t border-gray-200">
                  <th
                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                    <span class="lg:pl-2">Organisaties</span>
                  </th>
                  <th
                    class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                    Aantal deelnemers
                  </th>
                  <th
                    class="py-3 pr-6 text-xs font-medium leading-4 tracking-wider text-right text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-100">
                <tr class="hover:bg-gray-100" v-for="organisation in organisations.data" :key="organisation.id">
                  <td @click="openDetails(organisation)"
                    class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-no-wrap max-w-0">
                    <div class="flex items-center space-x-3 lg:pl-2">
                      <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-green-600"></div>
                      <a href="#" class="truncate hover:text-gray-600">
                        <span>{{ organisation.name }}</span>
                      </a>
                    </div>
                  </td>
                  <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                    <div class="flex items-center space-x-2">
                      <span class="flex-shrink-0 text-xs font-medium leading-5">{{ organisation.attendees.length
                      }}</span>
                    </div>
                  </td>
                  <td class="pr-6">
                    <div class="relative flex items-center justify-end">
                      <button @click="clickCampaignOptionDropdown(organisation.id)" id="project-options-menu-0"
                        aria-has-popup="true" type="button"
                        class="inline-flex items-center justify-center w-8 h-8 text-gray-400 transition duration-150 ease-in-out bg-transparent rounded-full hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100">
                        <!-- Heroicon name: dots-vertical -->
                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path
                            d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                        </svg>
                      </button>
                      <!--
                      Dropdown panel, show/hide based on dropdown state.

                      Entering: "transition ease-out duration-100"
                        From: "transform opacity-0 scale-95"
                        To: "transform opacity-100 scale-100"
                      Leaving: "transition ease-in duration-75"
                        From: "transform opacity-100 scale-100"
                        To: "transform opacity-0 scale-95"
                    -->
                      <div v-show="campaignOptionDropdown(organisation.id)"
                        class="absolute top-0 z-20 w-48 mx-3 mt-1 origin-top-right rounded-md shadow-lg right-7">
                        <div class="z-10 bg-white rounded-md shadow-xs" role="menu" aria-orientation="vertical"
                          aria-labelledby="project-options-menu-0">
                          <div class="py-1">
                            <a @click="deleteOrg(organisation)"
                              class="flex items-center px-4 py-2 text-sm leading-5 text-gray-700 group hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                              role="menuitem">
                              <!-- Heroicon name: trash -->
                              <svg
                                class="w-5 h-5 mr-3 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd"
                                  d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                  clip-rule="evenodd" />
                              </svg>
                              Verwijderen
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <!-- More project rows... -->
              </tbody>
            </table>
          </div>
        </div>
      </main>
  </layout>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  props: {
    errors: Object,
    organisations: Object
  },
  components: {
    Layout,
  },
  data: () => ({
    createOrganisationModal: false,
    campaignOptionDropdownId: null,
    organisationForm: {
      name: null
    }
  }),
  methods: {
    campaignOptionDropdown(id) {
      return this.campaignOptionDropdownId === id;
    },
    clickCampaignOptionDropdown(id) {
      if (this.campaignOptionDropdownId === id) {
        this.campaignOptionDropdownId = null;
      } else {
        this.campaignOptionDropdownId = id;
      }
    },
    openDetails(organisation) {
      this.$inertia.visit(organisation.links.show);
    },
    createOrganisation() {
      this.$inertia.post('/organisations', this.organisationForm);
    },
    deleteOrg(organisation) {
      this.campaignOptionDropdownId = null;
      if (confirm("Weet je zeker dat je deze organisatie wilt verwijderen?")) {
        this.$inertia.delete(organisation.links.delete, [], {
          replace: true,
          preserveState: false,
          preserveScroll: false,
        });
      }
    }
  }
}

</script>
